/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MerchantRadiusUnit {
    Kilometer = 'KILOMETER',
    Mile = 'MILE'
}

export function MerchantRadiusUnitFromJSON(json: any): MerchantRadiusUnit {
    return MerchantRadiusUnitFromJSONTyped(json, false);
}

export function MerchantRadiusUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantRadiusUnit {
    return json as MerchantRadiusUnit;
}

export function MerchantRadiusUnitToJSON(value?: MerchantRadiusUnit | null): any {
    return value as any;
}

